export default function runPropActions(props, newProps, actions) {
  Object.keys(actions).forEach(key => {
    let _old = props[key];
    let _new = newProps[key];

    _old = JSON.stringify(_old);
    _new = JSON.stringify(_new);

    if (_old == _new) {
      return;
    }

    let action = "";
    if (!_old && _new) {
      action = "enter";
    } else if (_old && _new) {
      action = "change";
    } else if (_old && !_new) {
      action = "leave";
    } else {
      return;
    }

    let cb = actions[key][action];
    if (typeof cb == "string") {
      this[cb](newProps, props);
    } else if (cb) {
      cb(newProps, props);
    }
  });
}



// WEBPACK FOOTER //
// ./utils/runPropActions.js